import { setTheme } from "theme/default/setTheme";

export const setColor_8bc3f5 = setTheme(({ theme }) => `color: ${theme.colors.color_8bc3f5}`);
